import { ENDPOINTS } from "../../apiConfig";
import { showToast } from "../../../components";
import axiosRequest from "../universal/axiosService";

// Internal DB
export const getApplicantsFromInternalDB = async (params) => {
    return await axiosRequest({
        method: 'POST',
        url: ENDPOINTS.SEARCH.INTERNAL_DB,
        data: params
    });
};

// Career Builder
export const getApplicantsFromCareerBuilder = async (params) => {
    return await axiosRequest({
        method: 'POST',
        url: ENDPOINTS.SEARCH.CAREER_BUILDER_SEARCH,
        data: params
    });
};

// Monster
export const getApplicantsFromMonster = async (params) => {
    return await axiosRequest({
        method: "POST",
        url: ENDPOINTS.SEARCH.MONSTER_SEARCH,
        data: params,
    });
};

// Pull Resume Career Builder
export const pullMonsterCandidateResume = async (params) => {
    return await axiosRequest({
        method: 'POST',
        url: ENDPOINTS.SEARCH.CAREER_BUILDER_RESUME_IMPORT,
        data: params
    });
}

// Resume Check
export const getCandidateResumeFromDB = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.CANDIDATES.GET}`,
        params: {
            coll: params.coll || null,
            ref: params.ref || null,
            fil: JSON.stringify(params.fil) || null,
            extret: params.extret
        },
    });
}

export const getMonsterResumesImport = async (params) => {
    // console.log("api bdmjobs params",params)
    return await axiosRequest({
        method: "POST",
        url: ENDPOINTS.SEARCH.MONSTER_RESUMES_IMPORT,
        data: params,
    });
};

export const getCareerBuilderResumesImport = async (params) => {
    // console.log("api bdmjobs params",params)
    return await axiosRequest({
        method: "POST",
        url: ENDPOINTS.SEARCH.CAREER_BUILDER_RESUMES_IMPORT,
        data: params,
    });
};

export const getLocations = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: ENDPOINTS.CITIES.GET_ALL,
        params: {
            coll: "City",
            lim:1500,
            fil: JSON.stringify({ "country": { "type": "OBJECT_ID", "value": params.country }, "zipCode": { "type": "SEARCH", "value": params.locationValue }, "stateName": { "type": "SEARCH", "value": params.locationValue }, "name": { "type": "SEARCH", "value": params.locationValue } })
        }
    });
}
export const getCityLocations = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: ENDPOINTS.CITIES.GET_ALL,
        params: params
    });
}

export const searchLocations = async (params) => {
    const fil = {
        zipCode: { type: "SEARCH", value: params.locationValue },
        stateName: { type: "SEARCH", value: params.locationValue },
        name: { type: "SEARCH", value: params.locationValue },
    };
    if (params.country) {
        fil.country = { type: "OBJECT_ID", value: params.country };
    }
    return await axiosRequest({
        method: "GET",
        url: ENDPOINTS.CITIES.GET_ALL,
        params: {
            coll: "City",
            lim: params.limit || 1500,
            fil: JSON.stringify(fil),
        },
    });
}

export const getCountries = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: ENDPOINTS.COUNTRIES.GET_ALL,
        params: {
            coll: "Country",
            fil: JSON.stringify({ "name": { "type": "NONE", "value": params.name } })
        }
    });
}